class MasonrySlideComponent extends SliderComponent {
  constructor() {
    super();
    this.checking = false;
    this.scrollend = false;
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    const activeSlider = this.sliderControlWrapper.querySelector(
      '.slider-counter__link--active',
    );
    this.activeSlider = activeSlider.getAttribute('aria-controls');
    this.enableSliderLooping = true;
    this.slideShow = this.querySelector('.slideshow');
    this.slideShowSlides = this.querySelectorAll('.slideshow__slide');
    this.sectionID = this.getAttribute('data-section-id');

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
    );

    this.sliderControlLinksArray.forEach((link) => {
      link.addEventListener('click', this.linkToSlide.bind(this));
    });

    this.slideShow.addEventListener(
      'scroll',
      this.updateCardTabIndex.bind(this),
    );

    const resizeObserver = new ResizeObserver(() => this.resizeActions());
    resizeObserver.observe(this.slider);
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
      behavior: 'smooth',
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active',
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true,
    );

    this.activeSlider =
      this.sliderControlButtons[this.currentPage - 1].getAttribute(
        'aria-controls',
      );
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth',
    });
  }

  resizeActions() {
    const self = this;
    if (window.innerWidth < 1025 && !this.checking) {
      self.setAttribute('aria-roledescription', 'Carousel');

      self.slideShow.setAttribute(
        'aria-labelledby',
        `Header-${self.sectionID}`,
      );
      self.slideShow.setAttribute('aria-roledescription', 'Related Articles');
      this.checking = true;
      setTimeout(() => {
        this.updateCardTabIndex();
        const parentElement = this.sliderControlWrapper.querySelector(
          '.slideshow__control-wrapper',
        );
        this.lastVisible = this.getLastVisibleChild(parentElement);

        if (this.lastVisible) {
          this.lastVisible.addEventListener(
            'keydown',
            this.tabEvent.bind(this),
            false,
          );
        } else {
          console.log('No visible children found.');
        }
        this.checking = false;
      }, 500);

      this.slideShowSlides.forEach((slide, index) => {
        slide.setAttribute('aria-roledescription', 'Article');
        slide.setAttribute(
          'aria-label',
          `${index + 1} of ${self.slideShowSlides.length}`,
        );
        slide.setAttribute('tabindex', '0');
        slide.setAttribute('aria-hidden', 'false');
        slide.addEventListener('focus', (e) => {
          e.preventDefault();
          const linkElements = slide.querySelector('a.link');
          linkElements.focus({focusVisible: true});
        });
        slide.addEventListener('keydown', (event) => {
          if (event.key === 'Tab' && event.shiftKey) {
            event.preventDefault();
            if (slide.previousSibling) {
              slide.previousSibling.focus();
              self.onButtonClick(event);
            } else {
              const activeSlider = this.sliderControlWrapper.querySelector(
                '.slider-counter__link--active',
              );
              activeSlider.focus();
            }
          }
          if (event.key === 'Tab' && !event.shiftKey) {
            event.preventDefault();
            if (slide.nextSibling) {
              slide.nextSibling.focus();
              const calc =
                this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth;
              this.slider.scrollTo({
                left: calc,
                behavior: 'smooth',
              });
            } else {
              const sectionParent = slide.closest('section');
              sectionParent.nextSibling
                .querySelector(
                  'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])',
                )
                .focus();
            }
          }
        });
      });
    } else if (window.innerWidth >= 1025) {
      self.removeAttribute('aria-roledescription');
      self.slideShow.removeAttribute('aria-labelledby');
      self.slideShow.removeAttribute('aria-roledescription');

      this.slideShowSlides.forEach((slide) => {
        const cards = document.querySelectorAll('.slider__slide');

        cards.forEach((card) => {
          card.removeAttribute('tabindex');
          card.removeAttribute('aria-hidden');
        });

        slide.removeAttribute('tabindex');
        slide.removeAttribute('aria-hidden');
        slide.removeEventListener('focus', () => {});
        slide.removeEventListener('keydown', () => {});
      });
    }

    if (window.innerWidth >= 960 && window.innerWidth < 1025) {
      this.sliderControlLinksArray.forEach((link, ind) =>
        link.setAttribute(
          'aria-label',
          `Viewing article ${ind + 1}-${ind + 2}-${ind + 3} of ${this.sliderControlLinksArray.length}`,
        ),
      );
    } else if (window.innerWidth >= 600 && window.innerWidth < 960) {
      this.sliderControlLinksArray.forEach((link, ind) =>
        link.setAttribute(
          'aria-label',
          `Viewing article ${ind + 1}-${ind + 2} of ${this.sliderControlLinksArray.length}`,
        ),
      );
    } else if (window.innerWidth < 600) {
      this.sliderControlLinksArray.forEach((link, ind) =>
        link.setAttribute(
          'aria-label',
          `Viewing article ${ind + 1} of ${this.sliderControlLinksArray.length}`,
        ),
      );
    }
  }

  tabEvent(event) {
    if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      const liSlide = document.getElementById(`${this.activeSlider}`);
      const focusSlide = liSlide.querySelector('a.link');
      focusSlide.focus({focusVisible: true});
    }
  }

  getLastVisibleChild(parentElement) {
    const children = Array.from(parentElement.children);
    let lastVisibleChild = null;

    for (let i = children.length - 1; i >= 0; i--) {
      const child = children[i];
      const style = window.getComputedStyle(child);
      if (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        parseFloat(style.opacity) > 0
      ) {
        lastVisibleChild = child;
        break;
      }
    }
    return lastVisibleChild;
  }

  isElementVisible(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.left >= 0 &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  updateCardTabIndex() {
    if (!this.scrollend) {
      setTimeout(() => {
        const cards = document.querySelectorAll('.slider__slide');

        cards.forEach((card) => {
          const link = card.querySelector('a');
          if (this.isElementVisible(card)) {
            card.tabIndex = 0;
            card.setAttribute('aria-hidden', 'false');
            link.tabIndex = 0;
          } else {
            card.tabIndex = -1;
            card.setAttribute('aria-hidden', 'true');
            link.tabIndex = -1;
          }
        });
        this.scrollend = false;
      }, 500);
    }
  }
}

customElements.define('masonryslide-component', MasonrySlideComponent);
